import { httpClient } from './httpClient';

const base = '/api/especialidades';

export const listarEspecialidades = () => httpClient.get(base);
export const obtenerEspecialidad = (id) => httpClient.get(`${base}/${id}`);
export const listarEspecialidadesPorNivel = (nivelId) => httpClient.get(`${base}/nivel/${nivelId}`);
export const crearEspecialidad = (payload) => httpClient.post(base, payload);
export const actualizarEspecialidad = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const eliminarEspecialidad = (id) => httpClient.del(`${base}/${id}`);

const especialidadesService = {
  listar: listarEspecialidades,
  obtener: obtenerEspecialidad,
  listarPorNivel: listarEspecialidadesPorNivel,
  crear: crearEspecialidad,
  actualizar: actualizarEspecialidad,
  eliminar: eliminarEspecialidad,
};

export default especialidadesService;
